import { X } from "lucide-react";

export interface FilterPill {
  key: string;
  label: string;
  value: string;
}

type Props = {
  pills: FilterPill[];
  onRemove: (key: string, value: string) => void;
  onClearAll: () => void;
};

export function FilterPills({ pills, onRemove, onClearAll }: Props) {
  if (pills.length === 0) return null;
  return (
    <div className="filter-pills" role="list">
      {pills.map((p) => (
        <span
          key={`${p.key}::${p.value}`}
          className="filter-pill"
          role="listitem"
        >
          <span className="filter-pill-label">{p.label}:</span>
          <span className="filter-pill-value">{p.value}</span>
          <button
            type="button"
            className="filter-pill-remove"
            aria-label={`Remove ${p.label} ${p.value} filter`}
            onClick={() => onRemove(p.key, p.value)}
          >
            <X size={12} strokeWidth={2.5} />
          </button>
        </span>
      ))}
      {pills.length >= 2 ? (
        <button
          type="button"
          className="filter-pills-clear"
          onClick={onClearAll}
        >
          Clear all
        </button>
      ) : null}
    </div>
  );
}
